import { isDefined } from '@sgme/fp';
import { FormattedMessage } from 'react-intl';
import type { TradeWay } from 'state/secondaryMarket/secondaryMarket.model';

interface TradeWayProps {
  tradeWay: Nullable<TradeWay>;
}

export function TradeWay({ tradeWay }: TradeWayProps) {
  return !isDefined(tradeWay) ? null : (
    <span className="fw-semibold">
      <FormattedMessage id={`form.tradeWay.${tradeWay}`} />
    </span>
  );
}
